import { html, svg } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { SuperElement } from '../../internals/super/SuperElement';
import { spinnerStyle } from './Spinner.styles';
import { ifDefined } from 'lit/directives/if-defined.js';
import { createIconComponent } from '../icon/Icon.component';

export type SpinnerSize = 'small' | 'medium' | 'large' | 'big';

export const IconSpinner = createIconComponent(
    'lr-icon-spinner',
    svg`
<path xmlns="http://www.w3.org/2000/svg" fillrule="evenodd" cliprule="evenodd" d="M25.2761 23.6127C27.0374 21.4666 28 18.7763 28 16H24C24 17.8508 23.3583 19.6444 22.1841 21.0751C21.0099 22.5059 19.376 23.4852 17.5607 23.8463C15.7454 24.2074 13.8611 23.9279 12.2288 23.0554C10.5965 22.1829 9.31726 20.7714 8.60897 19.0615C7.90068 17.3515 7.80721 15.4489 8.34448 13.6777C8.88175 11.9066 10.0165 10.3765 11.5554 9.34824C13.0944 8.31997 14.9422 7.85711 16.7841 8.03852C18.6261 8.21994 20.3481 9.0344 21.6569 10.3431L24.4853 7.51472C22.5222 5.5516 19.9391 4.3299 17.1762 4.05778C14.4133 3.78566 11.6415 4.47996 9.33316 6.02237C7.02478 7.56477 5.32263 9.85987 4.51672 12.5166C3.71081 15.1733 3.85102 18.0273 4.91345 20.5922C5.97588 23.1571 7.8948 25.2743 10.3432 26.5831C12.7917 27.8918 15.6182 28.311 18.3411 27.7694C21.064 27.2278 23.5149 25.7588 25.2761 23.6127Z" fill="url(#paint0_angular_406_11507)"></path>
            <defs xmlns="http://www.w3.org/2000/svg">
                <radialGradient id="paint0_angular_406_11507" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(16 16) rotate(0.1422) scale(12)">
                    <stop offset="0.749495" stop-color="currentColor" stop-opacity="1"></stop>
                    <stop offset="0.875" stop-color="currentColor" stop-opacity="0"></stop>
                </radialGradient>
            </defs>
`
);

@customElement('lr-spinner')
export class Spinner extends SuperElement {
    @property({ type: String, reflect: true }) size: SpinnerSize = 'medium';
    @property({ type: String }) dataCerberus = 'spinner';

    static styles = [SuperElement.styles, spinnerStyle];

    constructor() {
        super();
        this.size = 'medium';
    }

    renderElement() {
        return html`<lr-icon-spinner
            size=${this.size}
            class="spinner"
            data-cerberus="${ifDefined(this.dataCerberus)}"
        ></lr-icon-spinner> `;
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'lr-spinner': Spinner;
    }
}
